











import {Component} from "vue-property-decorator";
import BaseDialog from "@/component/Dialog/base-dialog.vue";

@Component({})
export default class InfoDialog extends BaseDialog {
}
